import React from "react";
import FilterHeader from "../../Shared/FilterHeader/FilterHeader";
import ActiveListingCard from "./ActiveListingCard";
import Paginate from "../../layout/Paginate";

const ActiveListing = ({ title, products }) => {
  return (
    <div className="grow">
      <FilterHeader title={title} />
      <Paginate
        itemsPerPage={5}
        data={products}
        element={(props) => <ActiveListingCard {...props} />}
        containerClassName="flex flex-col gap-4 mt-8"
      />
    </div>
  );
};

export default ActiveListing;
